const o = "Noto Script Fallback", F = {
  serif: "Noto Latin Fallback Serif",
  sans: "Noto Latin Fallback Sans"
}, L = {
  JP: "Noto CJK Fallback JP",
  KR: "Noto CJK Fallback KR",
  SC: "Noto CJK Fallback SC",
  TC: "Noto CJK Fallback TC"
}, s = "Noto Fallback Single Weight", t = "Noto Emoji Fallback", a = "Times New Roman", A = [
  a,
  "Times"
], l = `'${a}', 'Times', '${o}'`;
export {
  L as C,
  a as D,
  t as E,
  F as L,
  o as S,
  l as T,
  s as a,
  A as b
};
